<template>
  <div
    class="tw:flex tw:justify-between tw:border-b tw:border-denim-200 tw:p-3 tw:sm:p-5"
    data-testid="outreach-contact-profile-section"
  >
    <div class="tw:min-w-32 tw:flex tw:justify-center tw:flex-col">
      <slot name="title" />
    </div>
    <div
      class="tw:grow tw:min-w-0 tw:flex tw:flex-col tw:justify-center tw:wrap-anywhere"
    >
      <slot name="content">
        <OutreachContactProfileContent v-model="showAll">
          <slot />
        </OutreachContactProfileContent>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import OutreachContactProfileContent from "src/components/Outreach/OutreachContactProfileContent.vue";

const showAll = defineModel<boolean>({
  default: false,
});
</script>

<style lang="scss" scoped>
// Keep the stat as wide as its value so its hover popup anchors under it.
:deep(.outreach-contact-engagement),
:deep(.outreach-contact-top-reaction) {
  align-self: flex-start;
}

:deep(.base-outreach-contact-stat) {
  padding-inline: 0;
}
</style>
